import { Card, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { capitalized } from "../helpers/strings";
import { useGetOrderActionsQuery } from "../features/model/orderSlice";
import Loading from "./Loading";
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc';
import { useGetLineItemActionsQuery } from "../features/model/lineitemSlice";

dayjs.extend(utc);

const ActionsList = ({actions}) => {
    return <TableContainer>
        <Table>
        <TableHead>
            <TableRow>
                <TableCell>Time</TableCell>
                <TableCell>User</TableCell>
                <TableCell>Action</TableCell>
                <TableCell>Data</TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
        {actions.slice().sort((a, b) => {return a.timestamp.localeCompare(b.timestamp)}).map((action, i) => {
            return <TableRow key={`action_${i}`}>
                <TableCell>{dayjs.utc(action.timestamp).local().format('YYYY-MM-DD HH:mm:ss')}</TableCell>
                <TableCell>{action.user}</TableCell>
                <TableCell>{action.action.replaceAll("_", " ")}</TableCell>
                <TableCell>{action.data}</TableCell>
            </TableRow>
        })}
        </TableBody>
        </Table>
    </TableContainer>
};

const OrderActionsList = ({order}) => {
    const {data: actions, error, isLoading } = useGetOrderActionsQuery(order.id)

    if (isLoading || !actions) {
        return <Loading />;
    }

    return <ActionsList actions={actions.objects} />
};

const LineItemActionsList = ({lineitem}) => {
    const {data: actions, error, isLoading } = useGetLineItemActionsQuery(lineitem.id)

    if (isLoading) {
        return <Loading />;
    }

    return <ActionsList actions={actions.objects} />
};

export { OrderActionsList, LineItemActionsList };